<template>
  <section class="ps-header">
    <header-mobile
      :add-to-basket="addToBasket"
      v-if="rootStore.isMobile"
    ></header-mobile>
    <header-desktop :add-to-basket="addToBasket" v-else></header-desktop>
  </section>
</template>
<script>
import { EventBus, Events } from '@/eventbus/EventBus.js'
import HeaderMobile from './header/HeaderMobile.vue'
import HeaderDesktop from './header/HeaderDesktop.vue'

export default {
  data() {
    return {
      addToBasket: false
    }
  },
  components: {
    HeaderMobile,
    HeaderDesktop
  },
  created() {
    EventBus.on('addToBasket', () => {
      this.addToBasket = true
      setTimeout(() => {
        this.addToBasket = false
      }, 1000)
    })
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  align-items: center;
}

@media only screen and (min-width: 620px) {
  .header-container {
    margin-top: 10px;
  }
}
</style>
